var _mask, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRating(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "rating-mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 2,
    width: 22,
    height: 15
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9005 4.30299C16.1036 3.92152 15.9377 3.45825 15.5298 3.26826C14.134 2.61806 12.592 2.27492 10.9992 2.27492C5.37972 2.27492 0.824219 6.53579 0.824219 11.7918C0.824219 13.1385 1.12392 14.4471 1.69639 15.6523C1.88138 16.0417 2.3689 16.2172 2.78529 16.0442C3.20168 15.8711 3.38926 15.4152 3.20427 15.0257C2.72506 14.0168 2.47422 12.9216 2.47422 11.7918C2.47422 7.38812 6.29099 3.8182 10.9992 3.8182C12.3353 3.8182 13.6257 4.10535 14.7942 4.6497C15.2021 4.83969 15.6974 4.68446 15.9005 4.30299ZM19.1888 16.0848C19.6042 16.2599 20.0927 16.0869 20.28 15.6984C20.8667 14.4807 21.1742 13.1558 21.1742 11.7918C21.1742 9.61068 20.3864 7.54012 18.9638 5.86872C18.6801 5.5353 18.161 5.48018 17.8046 5.7456C17.4481 6.01103 17.3892 6.49648 17.6729 6.8299C18.865 8.23052 19.5242 9.96301 19.5242 11.7918C19.5242 12.936 19.2669 14.0449 18.7757 15.0643C18.5885 15.4528 18.7734 15.9097 19.1888 16.0848ZM12.8863 13.3056L16.0858 7.9189C16.3809 7.42219 16.1895 6.79582 15.6585 6.51986C15.1274 6.24391 14.4577 6.42287 14.1627 6.91959L10.963 12.3065C9.76469 12.3246 8.79922 13.2388 8.79922 14.364C8.79922 15.5004 9.78419 16.4217 10.9992 16.4217C12.2142 16.4217 13.1992 15.5004 13.1992 14.364C13.1992 13.9769 13.085 13.6148 12.8863 13.3056Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#rating-mask0)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.474426,
    width: 22,
    height: 20.5771,
    fill: "currentColor"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRating);
export default __webpack_public_path__ + "static/media/rating.df75723bdb857b047ff4c8579f6e5d10.svg";
export { ForwardRef as ReactComponent };